import { Championship, Collections } from "api";
import { useCollection } from "api/hooks/useCollection";

export const PUBLICS_CHAMPIONSHIPS_STORE_AS = "publicsChampionships";

export const usePublicsChampionships = (): Championship[] => {
    return (
        useCollection<Championship[]>(
            {
                collection: Collections.CHAMPIONSHIPS,
                where: ["public", "==", true],
                storeAs: PUBLICS_CHAMPIONSHIPS_STORE_AS,
            },
            true
        ) || []
    );
};
